import type { InAppPromotion } from '../../types/promotion'

/**
 * Olimp Marketplace conference promo (VI edition).
 * Last show day: 2026-10-02 (event day), Europe/Warsaw.
 */
export const OLIMP_CONFERENCE_2026: InAppPromotion = {
  id: 'olimp_marketplace_2026_10',
  imageSrc: '/promotions/olimp_konferencja.png',
  ctaUrl:
    'https://konferencja.vsprint.pl/?utm_source=ofertator&utm_medium=popup&utm_campaign=konferencja_promo_ofertator#kup-bilet',
  endsOn: '2026-10-02',
  delayMs: 5000,
  imageAltFallback: 'Olimp Marketplace conference — buy ticket',
}
